module.exports = __webpack_public_path__ + "static/img/mypage__recommand__img.658fa1eb.svg";